/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import AppContext from "AppContext";
import AlterarSenha from "components/AlterarSenha";
import SelecionarContrato from "components/SelecionarContrato";
import { mostrarSelecionarContrato } from "components/SelecionarContrato";
import SelecionarPapel from "components/SelecionarPapel";
import ModalPendencias from "components/ModalPendencias";
import { mostrarModalPendencias } from "components/ModalPendencias";
import pendenciaService from "services/PendenciaService";
import authService from "services/AuthService";
import { erroInesperado } from "services/Utils";
import { showLoading, hideLoading } from "components/Loading";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
  Button
} from "reactstrap";

const AdminNavbar = (props) => {
  const { state, actions } = useContext(AppContext)
  const navigate = useNavigate()
  const [alterarSenhaConfig, setAlterarSenhaConfig] = useState(null)
  const [pendenciasVerificadas, setPendenciasVerificadas] = useState(false)
  const verificouPendenciasRef = useRef(false)
  // SDD 034 (Decisao de escopo 2) - troca de papel em runtime, ja logado, reaproveitando o
  // mesmo modal SelecionarPapel do login. So aparece quando ha mais de 1 vinculo de site
  // elegivel (state.user.papeis - ver comentario em AppContext.js sobre de onde essa lista vem).
  const [trocandoPapel, setTrocandoPapel] = useState(false)
  const podeTrocarPapel = (state.user?.papeis?.length || 0) > 1

  // Sequenciamento intencional: so avalia abrir o SelecionarContrato depois que o
  // alerta de pendencias (se houver) ja foi verificado/fechado, para nao competir
  // com ele por atencao logo apos o login.
  useEffect(() => {
    if (pendenciasVerificadas && state.user && state.user.contratos && state.user.contratos.length > 0 && !state.contrato) {
      mostrarSelecionarContrato()
    }
  }, [state, pendenciasVerificadas])

  useEffect(() => {
    if (state.user && !verificouPendenciasRef.current) {
      verificouPendenciasRef.current = true
      pendenciaService.listar()
        .then(res => {
          if (res.success && res.data.length > 0) {
            mostrarModalPendencias(res.data, () => setPendenciasVerificadas(true))
          } else {
            setPendenciasVerificadas(true)
          }
        })
        .catch(() => setPendenciasVerificadas(true))
    }
  }, [state.user])

  const handleLogout = (ev) => {
    ev.preventDefault()
    actions.setToken(null)
    navigate('/auth/login')
  }

  const handleAlterarSenha = ev => {
    ev.preventDefault()
    setAlterarSenhaConfig({})
  }

  const handleAbrirTrocarPapel = ev => {
    ev.preventDefault()
    setTrocandoPapel(true)
  }

  const handleSelecionarPapel = async (idUsuarioPerfil) => {
    try {
      showLoading()
      const res = await authService.selecionarPapel(state.user.token, idUsuarioPerfil)
      if (res.success) {
        const papeis = state.user.papeis
        setTrocandoPapel(false)
        await actions.setToken(res.data.token, papeis)
        navigate('/admin')
      }
      hideLoading()
    } catch (ex) {
      hideLoading()
      if (ex.message == 'Unauthorized') {
        // token completo invalido/vinculo nao pertence mais ao usuario - forca novo login
        actions.setToken(null)
        navigate('/auth/login')
      } else {
        erroInesperado()
      }
    }
  }

  return (
    <>
      <AlterarSenha config={alterarSenhaConfig} onClose={() => setAlterarSenhaConfig(null)} />
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <div className="d-flex align-items-center" style={{ minWidth: 48 }}>
            <Button
              className="btn-icon-only rounded-circle ml-auto"
              color="secondary"
              type="button"
              onClick={() => actions.setTheme(state.theme === 'dark' ? 'light' : 'dark')}
              title="Trocar tema"
            >
              <span className="btn-inner-icon">
                <i className={state.theme === 'dark' ? "fas fa-sun" : "fas fa-moon"} />
              </span>
            </Button>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-grow-1">
            {(state.user && state.user.contratos && state.user.contratos.length > 0) && (
              <div className={state.theme === 'dark' ? "rounded border bg-dark d-flex" : "rounded border bg-white d-flex"} style={{ columnGap: 20 }}>
                <div className="px-2 py-1">
                  {state.contrato ? <>Contrato {state.contrato.numero}</> : <>Não selecionado</>}
                </div>
                <div className="d-flex px-2 py-1 border-left" style={{ cursor: 'pointer' }} onClick={() => mostrarSelecionarContrato()}>
                  <i className="bi-pencil"></i>
                </div>
              </div>
            )}
          </div>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={require("../../assets/img/theme/team-4-800x800.jpg")}
                    />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {state.user?.nome}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                {/* <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>*/}
                {podeTrocarPapel && (
                  <DropdownItem href="trocar_papel" onClick={handleAbrirTrocarPapel}>
                    <i className="ni ni-settings-gear-65" />
                    <span>Trocar Papel</span>
                  </DropdownItem>
                )}
                <DropdownItem href="alterar_senha" onClick={handleAlterarSenha}>
                  {/* <i className="ni ni-support-16" /> */}
                  <i className="ni ni-single-02" />
                  <span>Alterar Senha</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="sair" onClick={handleLogout}>
                  <i className="ni ni-user-run" />
                  <span>Sair</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
      <SelecionarContrato />
      <ModalPendencias />
      <SelecionarPapel
        isOpen={trocandoPapel}
        papeis={state.user?.papeis}
        onSelecionar={handleSelecionarPapel}
        onClose={() => setTrocandoPapel(false)}
      />
    </>
  );
};

export default AdminNavbar;
